import { useEffect, useState } from "react";
import api from "../api";
import { Spinner } from "../components/Logo";
import { PageHeader } from "../components/ui";
import { Trophy, Crown, Medal } from "lucide-react";

const tabs = [
  { key: "global", label: "All-time" },
  { key: "monthly", label: "Monthly" },
  { key: "weekly", label: "Weekly" },
];

export default function Leaderboard() {
  const [scope, setScope] = useState("global");
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get(`/leaderboards/${scope}`).then((r) => setData(r.data)).catch(() => {});
  }, [scope]);

  const rankColor = (r) => (r === 1 ? "#F26522" : r === 2 ? "#94A3B8" : r === 3 ? "#CD7F32" : "#64748B");

  return (
    <div data-testid="leaderboard-page">
      <PageHeader overline="Leaderboard" title="Top learners" desc="Earn XP by completing modules, passing quizzes and capturing flags. Climb the ranks!" />

      <div className="flex gap-2 mb-6">
        {tabs.map((t) => (
          <button key={t.key} onClick={() => setScope(t.key)} className={`chip px-4 py-2 ${scope === t.key ? "bg-[#F26522] text-white" : "bg-white/5 text-slate-300 hover:bg-white/10"}`} data-testid={`lb-tab-${t.key}`}>{t.label}</button>
        ))}
      </div>

      {!data ? <Spinner /> : (
        <>
          {/* podium */}
          <div className="grid grid-cols-3 gap-3 mb-6">
            {[1, 0, 2].map((pos) => {
              const u = data.leaderboard[pos];
              if (!u) return <div key={pos} />;
              const heights = { 0: "h-32", 1: "h-24", 2: "h-20" };
              return (
                <div key={pos} className="flex flex-col items-center justify-end">
                  <div className="h-12 w-12 rounded-full bg-[#1B2A4A] border-2 flex items-center justify-center font-heading font-bold text-lg mb-2" style={{ borderColor: rankColor(u.rank) }}>
                    {u.full_name.charAt(0)}
                  </div>
                  <span className="text-sm font-medium truncate max-w-full px-1">{u.full_name.split(" ")[0]}</span>
                  <span className="font-mono text-[#F26522] text-sm">{u.xp} XP</span>
                  <div className={`${heights[pos]} w-full rounded-t-lg mt-2 flex items-start justify-center pt-2 card`} style={{ background: `${rankColor(u.rank)}22` }}>
                    {u.rank === 1 ? <Crown style={{ color: rankColor(1) }} /> : <Medal style={{ color: rankColor(u.rank) }} />}
                  </div>
                </div>
              );
            })}
          </div>

          <div className="card overflow-hidden">
            {data.leaderboard.map((u) => (
              <div key={u.id} className={`flex items-center gap-4 px-5 py-3.5 border-b border-white/5 last:border-0 ${u.is_me ? "bg-[#F26522]/10" : ""}`} data-testid={`lb-row-${u.rank}`}>
                <span className="font-heading font-bold w-8 text-center" style={{ color: rankColor(u.rank) }}>#{u.rank}</span>
                <div className="h-9 w-9 rounded-full bg-[#1B2A4A] border border-white/10 flex items-center justify-center text-sm font-semibold text-[#38bdf8]">{u.full_name.charAt(0)}</div>
                <span className="flex-1 font-medium">{u.full_name} {u.is_me && <span className="text-xs text-[#F26522]">(You)</span>}</span>
                <span className="font-mono text-slate-300 flex items-center gap-1.5"><Trophy size={14} className="text-[#F26522]" /> {u.xp}</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
